var _a;
// Types
import { ButtonShape } from '../../../common/types/ButtonShape';
export var ButtonStylePropertiesByShape = (_a = {},
    _a[ButtonShape.SQUARE] = {
        borderRadius: '4px',
    },
    _a[ButtonShape.PILL] = {
        borderRadius: '180px',
    },
    _a);
//# sourceMappingURL=ButtonStylePropertiesByShape.js.map